import React, {FC, useCallback} from 'react';

import {Plural, Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {ButtonVariantsEnum} from '../../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {OkCancelDialog} from '../../../../../../libs/shared/ui/src/components/dialogs/okCancelDialog';
import {PopoverTransferProps} from '../../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {ConversationBaseModel} from '../../../../../models/api/conversationModel';

/*
 * Confirmation dialog.
 */

interface DestroyConfirmationDialogProps {
  conversations: ReadonlyArray<ConversationBaseModel>;
  onDestroyClick: () => void;
}

export const DestroyConfirmationDialog: FC<
  Omit<PopoverTransferProps, 'anchor'> & DestroyConfirmationDialogProps
> = (props) => {
  const {conversations, onRequestClose, onDestroyClick} = props;
  const onDestroyOkClick = useCallback(() => {
    onRequestClose();
    onDestroyClick();
  }, [onDestroyClick, onRequestClose]);

  return (
    <OkCancelDialog
      {...props}
      width={500}
      title={<Trans id="conversation-deletepermanently-title">Delete permanently</Trans>}
      okButtonLabel={<Trans id="conversation-deletepermanently-ok">Delete</Trans>}
      okButtonVariant={ButtonVariantsEnum.DANGER}
      onOkClick={onDestroyOkClick}
    >
      <Plural
        id="conversation-deletepermanently-content"
        value={conversations.length}
        one={
          <>
            This conversation will be permanently deleted from Front.
            <br />
            This <strong>cannot</strong> be undone.
          </>
        }
        other={
          <>
            These <strong>{conversations.length}</strong> conversations will be permanently deleted from
            Front.
            <br /> This <strong>cannot</strong> be undone.
          </>
        }
      />
    </OkCancelDialog>
  );
};
